var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteTooltipIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22.911,
    height: 27.1574,
    viewBox: "0 0 22.911 27.1574",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04282 0.947749H19.868V26.7217H3.04282V0.947749Z",
    fill: "#DDE0E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78654 9.93901C9.78654 9.61835 9.48075 9.3581 9.10398 9.3581H6.65801C6.28089 9.3581 5.97544 9.61835 5.97544 9.93901V12.2949C5.97544 12.6155 6.28089 12.8758 6.65801 12.8758H9.10398C9.48075 12.8758 9.78654 12.6155 9.78654 12.2949C9.78654 11.6428 9.78654 10.5911 9.78654 9.93901Z",
    fill: "#528BE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78654 4.44422C9.78654 4.12356 9.48075 3.86331 9.10398 3.86331C8.41254 3.86331 7.3491 3.86331 6.65801 3.86331C6.28089 3.86331 5.97544 4.12356 5.97544 4.44422V6.80008C5.97544 7.12074 6.28089 7.38099 6.65801 7.38099H9.10398C9.48075 7.38099 9.78654 7.12074 9.78654 6.80008C9.78654 6.14802 9.78654 5.09629 9.78654 4.44422Z",
    fill: "#528BE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78654 15.4338C9.78654 15.1131 9.48075 14.8529 9.10398 14.8529H6.65801C6.28089 14.8529 5.97544 15.1131 5.97544 15.4338V17.7897C5.97544 18.1103 6.28089 18.3706 6.65801 18.3706H9.10398C9.48075 18.3706 9.78654 18.1103 9.78654 17.7897C9.78654 17.1376 9.78654 16.0859 9.78654 15.4338Z",
    fill: "#528BE8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9354 9.93901C16.9354 9.61835 16.6299 9.3581 16.2528 9.3581H13.8068C13.43 9.3581 13.1243 9.61835 13.1243 9.93901V12.2949C13.1243 12.6155 13.43 12.8758 13.8068 12.8758H16.2528C16.6299 12.8758 16.9354 12.6155 16.9354 12.2949V9.93901Z",
    fill: "#528BE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9354 4.44422C16.9354 4.12356 16.6299 3.86332 16.2528 3.86332C15.5617 3.86332 14.4983 3.86332 13.8068 3.86332C13.43 3.86332 13.1243 4.12356 13.1243 4.44422V6.80009C13.1243 7.12075 13.43 7.38099 13.8068 7.38099H16.2528C16.6299 7.38099 16.9354 7.12075 16.9354 6.80009V4.44422Z",
    fill: "#528BE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9354 15.4338C16.9354 15.1131 16.6299 14.8529 16.2528 14.8529H13.8068C13.43 14.8529 13.1243 15.1131 13.1243 15.4338V17.7897C13.1243 18.1103 13.43 18.3706 13.8068 18.3706H16.2528C16.6299 18.3706 16.9354 18.1103 16.9354 17.7897V15.4338Z",
    fill: "#528BE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.655675 19.6096C0.949519 19.151 1.06794 18.58 0.985012 18.0229C0.9659 17.9003 0.956686 17.7746 0.956686 17.6462C0.956686 16.3545 1.89146 15.306 3.04294 15.306C4.19443 15.306 5.12954 16.3545 5.12954 17.6462C5.12954 17.7746 5.11999 17.9003 5.10224 18.0232C5.01965 18.5797 5.13808 19.1504 5.43124 19.6088C5.77593 20.1496 5.97934 20.8115 5.97934 21.5266C5.97934 23.3443 4.66369 24.8198 3.04294 24.8198C1.42254 24.8198 0.106893 23.3443 0.106893 21.5266C0.106893 20.8115 0.310297 20.1496 0.655675 19.6096Z",
    fill: "#97D391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4808 19.6096C17.7743 19.151 17.8927 18.58 17.8098 18.0229C17.791 17.9003 17.7814 17.7746 17.7814 17.6462C17.7814 16.3545 18.7166 15.306 19.868 15.306C21.0195 15.306 21.9543 16.3545 21.9543 17.6462C21.9543 17.7746 21.9451 17.9003 21.9273 18.0232C21.8444 18.5797 21.9628 19.1504 22.2563 19.6088C22.6007 20.1496 22.8041 20.8115 22.8041 21.5266C22.8041 23.3443 21.4884 24.8198 19.868 24.8198C18.2473 24.8198 16.9316 23.3443 16.9316 21.5266C16.9316 20.8115 17.1351 20.1496 17.4808 19.6096Z",
    fill: "#97D391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53089 19.6561V26.7217C2.53089 26.9622 2.76024 27.1574 3.04282 27.1574C3.3254 27.1574 3.55474 26.9622 3.55474 26.7217V19.6561C3.55474 19.4156 3.3254 19.2204 3.04282 19.2204C2.76024 19.2204 2.53089 19.4156 2.53089 19.6561Z",
    fill: "#AD8873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.356 19.6561V26.7217C19.356 26.9622 19.5854 27.1574 19.8679 27.1574C20.1505 27.1574 20.3799 26.9622 20.3799 26.7217V19.6561C20.3799 19.4156 20.1505 19.2204 19.8679 19.2204C19.5854 19.2204 19.356 19.4156 19.356 19.6561Z",
    fill: "#AD8873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3436 22.443C14.3436 21.829 14.0569 21.2402 13.5467 20.806C13.0369 20.3721 12.3451 20.1281 11.6236 20.1281C11.5117 20.1281 11.399 20.1281 11.2871 20.1281C10.5656 20.1281 9.87385 20.3721 9.36398 20.806C8.85376 21.2402 8.56708 21.829 8.56708 22.443V26.7217H14.3436V22.443Z",
    fill: "#666A6F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.511923 27.1574H22.399C22.6816 27.1574 22.911 26.9622 22.911 26.7217C22.911 26.4812 22.6816 26.286 22.399 26.286H0.511923C0.229342 26.286 0 26.4812 0 26.7217C0 26.9622 0.229342 27.1574 0.511923 27.1574Z",
    fill: "#B9BDC3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0099 0.580906C21.0099 0.426966 20.9379 0.279125 20.8099 0.170205C20.6819 0.0612856 20.5085 0 20.3273 0C17.3547 0 5.55594 0 2.58337 0C2.40215 0 2.22878 0.0612856 2.1008 0.170205C1.97282 0.279125 1.90081 0.426966 1.90081 0.580906V1.31459C1.90081 1.46882 1.97282 1.61637 2.1008 1.72558C2.22878 1.8345 2.40215 1.8955 2.58337 1.8955H20.3273C20.5085 1.8955 20.6819 1.8345 20.8099 1.72558C20.9379 1.61637 21.0099 1.46882 21.0099 1.31459C21.0099 1.08165 21.0099 0.813849 21.0099 0.580906Z",
    fill: "#B9BDC3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteTooltipIcon);
export default __webpack_public_path__ + "static/media/site-tooltip-icon.8223583961cd3a5a15f54b84eddf6a97.svg";
export { ForwardRef as ReactComponent };